import { withInstall } from '@tav-ui/utils/with-install'
import CountTo from './src/count-to.vue'
const TaCountTo = withInstall(CountTo)
export { TaCountTo }
export default TaCountTo
